"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Modal functionality
function initModal() {
    const modal = document.getElementById('suggest-seller-modal');
    const openBtn = document.getElementById('suggest-seller-btn');
    const closeBtn = document.querySelector('.suggest-seller-modal-close');
    const overlay = document.querySelector('.suggest-seller-modal-overlay');
    const submitAnotherBtn = document.getElementById('submit-another-btn');
    if (!modal || !openBtn)
        return;
    // Open modal
    openBtn.addEventListener('click', () => {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        // Add a slight delay for animation
        setTimeout(() => {
            modal.classList.add('is-open');
        }, 10);
    });
    // Close modal function
    const closeModal = () => {
        modal.classList.remove('is-open');
        setTimeout(() => {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }, 300);
    };
    // Close on X button
    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener('click', closeModal);
    // Close on overlay click
    overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closeModal);
    // Submit another button
    submitAnotherBtn === null || submitAnotherBtn === void 0 ? void 0 : submitAnotherBtn.addEventListener('click', () => {
        const form = document.getElementById('suggest-grower-form');
        const formWrapper = form === null || form === void 0 ? void 0 : form.closest('.form-wrapper');
        const successMessage = document.getElementById('success-message');
        if (form && successMessage && formWrapper) {
            form.reset();
            form.style.display = '';
            successMessage.style.display = 'none';
        }
    });
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
}
// Grower Suggestion Form Handler
function initGrowerForm() {
    var _a;
    const form = document.getElementById('suggest-grower-form');
    if (!form)
        return;
    console.log('Grower form handler attached!');
    // Remove any existing event listeners by cloning
    const newForm = form.cloneNode(true);
    (_a = form.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newForm, form);
    // Attach to the new cloned form
    newForm.addEventListener('submit', (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('Form submit intercepted!');
        const submitButton = newForm.querySelector('.submit-button');
        const buttonText = submitButton === null || submitButton === void 0 ? void 0 : submitButton.querySelector('.button-text');
        const buttonLoader = submitButton === null || submitButton === void 0 ? void 0 : submitButton.querySelector('.button-loader');
        const messagesDiv = document.getElementById('form-messages');
        const successMessage = document.getElementById('success-message');
        // Disable submit button
        if (submitButton)
            submitButton.disabled = true;
        if (buttonText)
            buttonText.style.display = 'none';
        if (buttonLoader)
            buttonLoader.style.display = 'inline-block';
        if (messagesDiv)
            messagesDiv.style.display = 'none';
        try {
            // Create FormData object
            const formData = new FormData(newForm);
            formData.append('action', 'suggest_grower');
            formData.append('nonce', window.growerFormData.nonce);
            console.log('Submitting to:', window.growerFormData.ajaxUrl);
            // Submit via AJAX
            const response = yield fetch(window.growerFormData.ajaxUrl, {
                method: 'POST',
                body: formData,
            });
            const result = yield response.json();
            console.log('Response:', result);
            if (result.success) {
                newForm.style.display = 'none';
                if (successMessage)
                    successMessage.style.display = 'block';
                successMessage === null || successMessage === void 0 ? void 0 : successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            else {
                showMessage(messagesDiv, result.data.message || 'An error occurred. Please try again.', 'error');
                if (submitButton)
                    submitButton.disabled = false;
                if (buttonText)
                    buttonText.style.display = 'inline-block';
                if (buttonLoader)
                    buttonLoader.style.display = 'none';
            }
        }
        catch (error) {
            console.error('Form submission error:', error);
            showMessage(messagesDiv, 'An unexpected error occurred. Please try again.', 'error');
            if (submitButton)
                submitButton.disabled = false;
            if (buttonText)
                buttonText.style.display = 'inline-block';
            if (buttonLoader)
                buttonLoader.style.display = 'none';
        }
    }), true); // Use capture phase
}
function showMessage(element, message, type) {
    if (!element)
        return;
    element.textContent = message;
    element.className = `form-messages ${type}`;
    element.style.display = 'block';
}
// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initModal();
        initGrowerForm();
    });
}
else {
    initModal();
    initGrowerForm();
}
